import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { FaEye } from 'react-icons/fa';
import vesselEdit from '../../images/icons/grid-icon-vessel-edit.svg';
import vesselViewDoc from '../../images/icons/grid-icon-view-doc.svg';
import ApiPagination from '../common/ApiPagination';
import deletePpeComponentMaster from './queries/deletePpeComponentMaster';
import ConfirmDelete from '../Modal/ConfirmDelete';
import AddVesselGroup from './AddVesselGroup';
import getGroupVesselList from './queries/getGroupVesselList';
import GeneralVesselListModal from './GeneralVesselListModal';

const VesselGroupTable = ({ search, modal, setModal, mode, setMode, policies }) => {
  const history = useHistory();
  const [pageNumber, setpageNumber] = useState(1);
  const [rowsCount, setrowsCount] = useState(10);
  const [deleteModal, setDeleteModal] = useState(false);
  const [vesselListModal, setVesselListModal] = useState(false);
  const [generalVesselList, setGeneralVesselList] = useState(false);

  const [items, setItems] = useState({
      vesselGroupName: '',
      vesselIds: []
  });
  useEffect(() => {
    if (search?.length > 2) {
    setpageNumber(1);
    }
   }, [search]);
  const dataone = {
    Page: pageNumber,
    PageSize: rowsCount,
    searchCriteria: search?.length > 2 ? search : '',
    isAll: false
  };

  const { mutate: deletePpeComponent } = deletePpeComponentMaster();
  const { data: VesselGroupList, isLoading: componentsLoading } = getGroupVesselList(dataone);
  const handleEdit = (item) => {
     const ids = [];
     item.mappedVessels.forEach((id) => {
      ids.push(id.vesselId);
     });
    item.vesselIds = ids;
      setMode('edit');
      setItems(item);
      setModal(true);
  };
  const handleNav = (item) => {
    history.push(`/ppe/${item.vesselGroupId}`);
  };
  const confrimDelete = () => {
    deletePpeComponent(items?.id);
    setDeleteModal(false);
    setItems({
      vesselGroupName: '',
      vesselIds: []
    });
  };
  const cancelModal = () => {
      setDeleteModal(false);
      setItems({
        vesselGroupName: '',
        vesselIds: []
      });
  };

  return (
    <>
      {modal && (
        <AddVesselGroup
          {...{
            modal,
            setModal,
            policies,
            items,
            setItems,
            mode,
            setMode
          }}
        />
      )}
      {vesselListModal && (
        <GeneralVesselListModal
          {...{
            vesselListModal,
            setVesselListModal,
            generalVesselList
          }}
        />
      )}
      {deleteModal && (
        <ConfirmDelete
          modal={deleteModal}
          setModal={setDeleteModal}
          handleDelete={confrimDelete}
          handleCancel={cancelModal}
          message="Delete"
          subMessage="This will permanently delete the component from the Component Mapping screen"
        />
      )}
      <div className="items-table-rebuild-wrap">
        <table className="items-table-rebuild">
    <thead className="font-muli">
        <tr>
           <th colSpan="1" className="w-[15%] font-muli">Vessel Group</th>
           <th colSpan="1" className="text-center py-3 px-6 font-muli center-text">Vessels Mapped Count</th>
           <th colSpan="1" className="w-3/5 hidden-padding font-muli">Mapped Vessels</th>
           <th colSpan="1" className="w-[10%] font-muli">Actions</th>
        </tr>
    </thead>
          <tbody className="">
            {componentsLoading && (
              <tr>
                <td colSpan="4">Loading...</td>
              </tr>
            )}
            {VesselGroupList?.data?.totalItems !== 0 ? (
              <>
                {VesselGroupList?.data?.items?.map((item) => (
                  <tr key={item?.id} className="">
                    <td title={item?.vesselGroupName}>
                      <label>{item?.vesselGroupName}</label>
                    </td>
                    <td className="text-center">
                       <label>{item?.mappedVessels?.length}</label>
                    </td>
                    <td className="hidden-padding">
                    {item?.mappedVessels?.map((vessel) => (
                                  <span
                                      className=" text-gray-100 p-1 block text-sm font-muli text-left input-label vessel-group-label"
                                  >
              <p className="text-gray-100 vessel-text-color">
                {vessel?.vesselName}
                <span> [</span>
                {vessel?.imoNumber}
                <span>, VC</span>
                <span>
                {vessel?.vesselCode}
                </span>
                 <span>]</span>
              </p>
                                  </span>
                      ))}
                    </td>
                    <td className="flex items-center space-x-2">
                      <button type="button" onClick={() => handleNav(item)}>
                        <img src={vesselViewDoc} alt="EditIcon" title="Item" className="action-icon w-6 h-4" />
                      </button>
                      {!item?.vesselGroupName?.toLowerCase().includes('general') && (
  <button type="button" onClick={() => handleEdit(item)}>
    <img
      src={vesselEdit}
      alt="DeleteIcon"
      title="Edit"
      className="action-icon w-6 h-6"
    />
  </button>
)}
{(item?.vesselGroupName?.toLowerCase().includes('general') && item?.mappedVessels?.length > 0) && (
<button
type="button"
onClick={() => {
  setGeneralVesselList(item);
  setVesselListModal(true);
}}
>
   <FaEye title="View Vessels" />
</button>
)}
                    </td>
                  </tr>
                ))}
              </>
            ) : (
              <tr>
                <td colSpan="">No Data Found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {VesselGroupList?.data?.totalItems > 5 && (
        <ApiPagination
          currentPage={VesselGroupList?.data?.currentPage}
          totalItems={VesselGroupList?.data?.totalItems}
          pageSize={VesselGroupList?.data?.pageSize}
          pageNumber={pageNumber}
          setpageNumber={setpageNumber}
          paginationRowList={[10, 20, 30, 40, 50]}
          rowsCount={rowsCount}
          handleRowsCount={setrowsCount}
          totalPages={VesselGroupList?.data?.totalPages}
        />
      )}
    </>
  );
};

export default VesselGroupTable;
